export default __webpack_public_path__ + "static/media/natacion.d3eb122f.jpg";